/* eslint-disable no-param-reassign */
import { Notify } from "quasar";

import DialogService, {
  type DialogServiceFunction,
} from "shared/modals/DialogService";
import { DialogTheme } from "shared/modals/types";
import type { Nullable } from "shared/types";

import type { App } from "./app";
import { getLocaleText } from "./i18n";

let errorDialog: Nullable<ReturnType<DialogServiceFunction>> = null;
let isOpen = false;

export type ToastDialogOptions = {
  color?: string;
  timeout?: number;
};

export const AlertDialog = (
  message: string,
  options: ToastDialogOptions = {}
) => {
  Notify.create({
    color: options.color || "primary",
    message,
    position: "center",
    timeout: options.timeout || Math.max(1000, message.length * 40),
  });
};

export const ToastDialog = (
  message: string,
  options: ToastDialogOptions = {}
) => {
  Notify.create({
    color: options.color || "ds-denim-9",
    message,
    timeout: options.timeout || Math.max(1000, message.length * 40),
  });
};

export const ErrorDialog = (
  title: string,
  error: any,
  customMessage: string = ""
) => {
  if (errorDialog && isOpen) {
    errorDialog.hide();
  }

  let message: string = customMessage;
  let dialogTitle: string;

  if (error?.response?.status === 401) {
    dialogTitle = getLocaleText("boot_alert.dialog_title");
  } else {
    dialogTitle = title;
  }

  if (!message) {
    message =
      error?.response?.data?.message ||
      error?.response?.data?.errors?.[0]?.detail ||
      error?.response?.data?.errors?.[0]?.title ||
      error.message;
  }

  errorDialog = DialogService.alert({
    confirmButtonProps: { class: "" },
    confirmLabel: getLocaleText("global.close"),
    message,
    theme: DialogTheme.DANGER,
    title: dialogTitle,
  })
    .onOk(() => {
      isOpen = false;
    })
    .onCancel(() => {
      isOpen = false;
    });

  isOpen = true;
};

export default ({ app }: { app: App }) => {
  app.config.globalProperties.$alert = AlertDialog;
  app.config.globalProperties.$toast = ToastDialog;
  app.config.globalProperties.$error = ErrorDialog;
};
